import { observer } from "mobx-react-lite";
import React, { Fragment } from "react";
import Button from "@material-ui/core/Button";
import { useStore } from "../../../app/stores/store";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { toast } from "react-toastify";
import CCTipoDeDocumentoUpdate from "../../FormulariosCC/update/CCTipoDeDocumentoUpdate";

export default observer(function CCTiposDeCuentasList() {
  const { CCTiposDeDocumentosStore, modalStore } = useStore();
  const { CCTipoDeDocumentoByCodigo, deleteCCTipoDeDocumento } =
    CCTiposDeDocumentosStore;
  return (
    <>
      <TableContainer>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <b>Codigo de Documento</b>
              </TableCell>
              <TableCell align="center">
                <b>Nombre</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {CCTipoDeDocumentoByCodigo.map((activities) => {
              return (
                <TableRow key={activities.codigoTipoDocumento}>
                  <TableCell component="th" scope="row" align="center">
                    {activities.codigoTipoDocumento}
                  </TableCell>
                  <TableCell align="center">{activities.nombre}</TableCell>
                  <IconButton
                    aria-label="edit"
                    onClick={() =>
                      modalStore.openModal(
                        <CCTipoDeDocumentoUpdate
                          idCuenta={activities.codigoTipoDocumento}
                        />,
                        'mini'
                      )
                    }
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    aria-label="delete"
                    color="secondary"
                    onClick={() => {
                      modalStore.openModal(
                        <div>
                          <h4>
                            ¿Seguro que quiere borrar este tipo de Documento?
                          </h4>
                          <Button
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                              deleteCCTipoDeDocumento(
                                activities.codigoTipoDocumento
                              );
                              modalStore.closeModal();
                            }}
                          >
                            si
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() => {
                              modalStore.closeModal();
                            }}
                          >
                            No
                          </Button>
                        </div>,
                        'mini'
                      );
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
});
